(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8241],{

/***/ 76097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ recipes; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs
var useIsFetching = __webpack_require__(38347);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useDebounce.js
var useDebounce = __webpack_require__(63611);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(34810);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/api/routes/recipes/queries/index.ts + 8 modules
var queries = __webpack_require__(67723);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/SearchBar/index.ts + 1 modules
var SearchBar = __webpack_require__(54086);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var copy = {
  heading: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "Explore popular solutions to\xA0empower every team"
  }),
  overline: "Recipes"
};

var Hero = function Hero(_ref) {
  var query = _ref.query,
      onQueryChange = _ref.onQueryChange,
      isQueryLoading = _ref.isQueryLoading;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroRecipeBase, {
      variant: "centered",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBar/* default */.Z, {
          "aria-label": "Search recipes",
          name: "recipes",
          placeholder: "Search recipes...",
          value: query,
          onChange: function onChange(_e, value) {
            return onQueryChange(value !== null && value !== void 0 ? value : "");
          },
          onClear: function onClear() {
            return onQueryChange("");
          },
          isLoading: isQueryLoading
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "ejnicbs2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroRecipeBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "ejnicbs1"
} : 0)(recipes_Hero/* Wrapper */.im, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80px;padding-bottom:80px;}}" + ( true ? "" : 0));

var StyledHeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "ejnicbs0"
} : 0)( true ? {
  name: "1tl48zq",
  styles: "max-width:520px"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/Filters/FilterSelect.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function FilterSelect_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var FilterSelect = function FilterSelect(_ref) {
  var id = _ref.id,
      options = _ref.options,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      mobileConfirmationBehaviour: true,
      multiselect: true
    },
    label: placeholder
  }),
      state = _useSelect.state,
      filteredOptions = _useSelect.filteredOptions,
      getControlProps = _useSelect.getControlProps,
      getSelectProps = _useSelect.getSelectProps;

  var selectId = "".concat(id, "-select");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FilterSelect_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small"
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: placeholder,
      counter: true
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: selectId,
      name: selectId,
      open: state.open,
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      listItemComponent: Select/* MenuItemWithCheckbox */.N1
    }, getSelectProps()))]
  });
};

var FilterSelect_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehymc0w0"
} : 0)( true ? {
  name: "js0777",
  styles: "width:100%;z-index:2"
} : 0);

/* harmony default export */ var Filters_FilterSelect = (FilterSelect);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/Filters/Filters.tsx


function Filters_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Filters_copy = {
  description: "Discover what you are looking for by filtering recipes:"
};

var Filters = function Filters(_ref) {
  var _ref$onFilterChange = _ref.onFilterChange,
      onFilterChange = _ref$onFilterChange === void 0 ? function () {
    return null;
  } : _ref$onFilterChange;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useFiltersQuery = (0,queries/* useFiltersQuery */.s_)({
    args: []
  }),
      filters = _useFiltersQuery.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
        tag: "p",
        variant: "pMedium",
        tokens: {
          color: theme.palette.twilio.gray[60]
        },
        children: Filters_copy.description
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        gap: "small",
        columns: 1,
        overrides: {
          lg: filters === null || filters === void 0 ? void 0 : filters.length
        },
        children: filters === null || filters === void 0 ? void 0 : filters.map(function (_ref2) {
          var id = _ref2.id,
              displayName = _ref2.displayName,
              searchableId = _ref2.searchableId,
              options = _ref2.options;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_FilterSelect, {
            id: id,
            placeholder: displayName,
            options: options,
            onSelect: function onSelect(selectedOptions) {
              return onFilterChange(searchableId, selectedOptions);
            }
          }, id);
        })
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1tycmaq2"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{justify-content:unset;padding-top:24px;padding-bottom:40px;row-gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1tycmaq1"
} : 0)( true ? {
  name: "2cp9od",
  styles: "margin:8px"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1tycmaq0"
} : 0)("max-width:520px;row-gap:8px;margin:0 auto;margin-bottom:8px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:1280px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{padding:0 80px;}" + ( true ? "" : 0));

/* harmony default export */ var Filters_Filters = (Filters);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/RecipeDivider/RecipeDivider.tsx





var RecipeDivider = function RecipeDivider() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecipeDivider_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

var RecipeDivider_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ejalyxe0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));

/* harmony default export */ var RecipeDivider_RecipeDivider = (RecipeDivider);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/Filters/useFilters.ts



function useFilters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFilters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFilters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFilters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var useFilters = function useFilters() {
  var _useState = (0,react.useState)({}),
      filters = _useState[0],
      setFilters = _useState[1];

  var updateFilters = function updateFilters(index, options) {
    setFilters(function (prevState) {
      return useFilters_objectSpread(useFilters_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, index, options));
    });
  };

  var filtersString = Object.entries(filters).map(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return value.length ? "".concat(name, ":\"").concat(value.map(function (el, index) {
      return "".concat(index > 0 ? " OR ".concat(name, ":\"") : "").concat(el.value, "\"");
    }).join("")) : undefined;
  }).filter(Boolean).join(" AND ");
  return {
    updateFilters: updateFilters,
    filtersString: filtersString
  };
};

/* harmony default export */ var Filters_useFilters = (useFilters);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/Card/Card.tsx


function Card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Card = function Card(_ref) {
  var authors = _ref.authors,
      industries = _ref.industries,
      teams = _ref.teams,
      experienceLevel = _ref.experienceLevel,
      title = _ref.title,
      description = _ref.description,
      slug = _ref.slug;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* default */.ZP, {
    href: (0,getAbsoluteUrl/* default */.Z)("/recipes/".concat(slug), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
          children: [industries === null || industries === void 0 ? void 0 : industries.map(function (industry, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: industry
            }, key);
          }), teams === null || teams === void 0 ? void 0 : teams.map(function (team, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: team
            }, key);
          }), experienceLevel && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: experienceLevel
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h3",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          children: description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
          children: authors === null || authors === void 0 ? void 0 : authors.map(function (_ref2, key) {
            var name = _ref2.name,
                headshot = _ref2.headshot;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* AccessoriesRow */.OW, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardRecipeAuthor, {
                contentfulLoader: true,
                alt: name,
                size: "small",
                src: headshot.src
              }, name), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Label */.__, {
                variant: "textTiny",
                children: ["Made by ", name]
              })]
            }, key);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        alignment: "left",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Use this recipe"
        })
      })]
    })
  });
};

var StyledCardRecipeAuthor = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Card/* Author */.S3,  true ? {
  target: "emp2qpi0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/CardsGroup/CardsGroup.tsx


var _excluded = ["children"];

function CardsGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsGroup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CardsGroup = function CardsGroup(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, CardsGroup_objectSpread(CardsGroup_objectSpread({
    columns: 1,
    overrides: {
      lg: 3
    }
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var CardsGroup_CardsGroup = (CardsGroup);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/CardsSection/CardsSection.tsx



var CardsSection_excluded = ["title", "isEmpty", "isLoading", "children"];

function CardsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CardsSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CardsSection = function CardsSection(_ref2) {
  var title = _ref2.title,
      isEmpty = _ref2.isEmpty,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      children = _ref2.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, CardsSection_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_StyledSectionBase, CardsSection_objectSpread(CardsSection_objectSpread({
    isEmpty: isEmpty,
    variant: "noCopy"
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
        isEmpty: isEmpty,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h4",
          children: title
        })
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingOverlay, {
      "aria-busy": isLoading,
      isLoading: isLoading
    })]
  }));
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1ydzngx2"
} : 0)("margin-bottom:", function (_ref3) {
  var isEmpty = _ref3.isEmpty;
  return isEmpty ? "16px" : "40px";
}, ";" + ( true ? "" : 0));

var CardsSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1ydzngx1"
} : 0)("position:relative;", function (_ref4) {
  var isEmpty = _ref4.isEmpty;
  return isEmpty && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(Section/* Wrapper */.im, "{padding-top:40px;padding-bottom:40px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var LoadingOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ydzngx0"
} : 0)("opacity:0;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.neutrals.white[100];
}, ";position:absolute;top:0;left:0;bottom:0;right:0;width:100%;transition:opacity ease-in-out 0.3s;z-index:1;pointer-events:none;", function (_ref6) {
  var isLoading = _ref6.isLoading;
  return isLoading && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CardsSection_CardsSection = (CardsSection);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/FeaturedRecipes/FeaturedRecipes.tsx





var FeaturedRecipes = function FeaturedRecipes(_ref) {
  var recipes = _ref.recipes;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsSection_CardsSection, {
    title: "Featured recipes",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGroup_CardsGroup, {
      children: recipes.map(function (_ref2) {
        var authors = _ref2.authors,
            industries = _ref2.industries,
            title = _ref2.title,
            description = _ref2.description,
            slug = _ref2.slug;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, {
          authors: authors,
          industries: industries,
          title: title,
          description: description,
          slug: slug
        }, title);
      })
    })
  });
};

/* harmony default export */ var FeaturedRecipes_FeaturedRecipes = (FeaturedRecipes);
// EXTERNAL MODULE: ../../libs/utils/useNextPageTrigger/index.ts + 1 modules
var useNextPageTrigger = __webpack_require__(78299);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/RecipesGrid/useRecipesGrid.ts




var useRecipesGrid = function useRecipesGrid(_ref) {
  var _data$pages$length;

  var _ref$query = _ref.query,
      query = _ref$query === void 0 ? "" : _ref$query,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? "" : _ref$filters;

  var _useRecipesQuery = (0,queries/* useRecipesQuery */.R0)({
    args: [{
      filters: filters,
      query: query
    }],
    options: {
      keepPreviousData: true
    }
  }),
      data = _useRecipesQuery.data,
      hasNextPage = _useRecipesQuery.hasNextPage,
      isLoading = _useRecipesQuery.isLoading,
      fetchNextPage = _useRecipesQuery.fetchNextPage;

  var flattenedPages = (0,react.useMemo)(function () {
    return data === null || data === void 0 ? void 0 : data.pages.flatMap(function (_ref2) {
      var hits = _ref2.hits;
      return hits;
    });
  }, [data === null || data === void 0 ? void 0 : data.pages]);
  return {
    hasNextPage: hasNextPage,
    isLoading: isLoading,
    isEmpty: !isLoading && !hasNextPage && flattenedPages && (flattenedPages === null || flattenedPages === void 0 ? void 0 : flattenedPages.length) === 0,
    nextPageTrigger: (0,useNextPageTrigger/* default */.Z)({
      isLoading: isLoading,
      totalDownloadedPages: (_data$pages$length = data === null || data === void 0 ? void 0 : data.pages.length) !== null && _data$pages$length !== void 0 ? _data$pages$length : -1,
      hasNextPage: hasNextPage !== null && hasNextPage !== void 0 ? hasNextPage : false,
      onNextPage: function onNextPage() {
        fetchNextPage === null || fetchNextPage === void 0 ? void 0 : fetchNextPage();
      },
      loadMargin: "0%"
    }),
    flattenedPages: flattenedPages
  };
};

/* harmony default export */ var RecipesGrid_useRecipesGrid = (useRecipesGrid);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/components/RecipesGrid/RecipesGrid.tsx







var RecipesGrid = function RecipesGrid(_ref) {
  var recipes = _ref.recipes,
      isEmpty = _ref.isEmpty,
      isLoading = _ref.isLoading,
      title = _ref.title,
      nextPageTrigger = _ref.nextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_CardsSection, {
    isEmpty: isEmpty,
    isLoading: isLoading,
    title: title,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsGroup_CardsGroup, {
      "data-testid": "loading-overlay",
      "aria-live": "polite",
      "aria-busy": isLoading,
      children: [recipes === null || recipes === void 0 ? void 0 : recipes.map(function (_ref2) {
        var title = _ref2.title,
            authors = _ref2.authors,
            industries = _ref2.industries,
            teams = _ref2.teams,
            experienceLevel = _ref2.experienceLevel,
            description = _ref2.description,
            slug = _ref2.slug;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, {
          authors: authors,
          industries: industries,
          teams: teams,
          experienceLevel: experienceLevel,
          title: title,
          description: description,
          slug: slug
        }, title);
      }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pMedium",
          children: "Sorry, we couldn\u2019t find any recipes that match the search criteria."
        })
      })]
    }), nextPageTrigger]
  });
};

/* harmony default export */ var RecipesGrid_RecipesGrid = (RecipesGrid);
// EXTERNAL MODULE: ./src/views/Recipes/LandingPage/assets/OgRecipes.png
var OgRecipes = __webpack_require__(27305);
var OgRecipes_default = /*#__PURE__*/__webpack_require__.n(OgRecipes);
;// CONCATENATED MODULE: ./src/views/Recipes/LandingPage/Recipes.tsx





















var Recipes_copy = {
  pageTitle: "Twilio Segment Recipes",
  pageDescription: "Explore top use cases for Twilio Segment and the tools that power them. Implement Segment once, integrate 250+ tools with the flip of a switch, and unlock thousands of new uses cases for marketing, personalization, analytics, and more."
};

var getCardsSectionTitle = function getCardsSectionTitle(query, filtersString) {
  if (query === "" && filtersString === "") {
    return "All recipes";
  }

  if (query === "") {
    return null;
  }

  return "Search results for \"".concat(query, "\" in recipes");
};

var RecipesView = function RecipesView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState = (0,react.useState)(""),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = (0,react.useState)(query),
      debouncedQuery = _useState2[0],
      setDebouncedQuery = _useState2[1];

  (0,useDebounce/* default */.Z)(function () {
    return setDebouncedQuery(query);
  }, 200, [query]);

  var _useFilters = Filters_useFilters(),
      updateFilters = _useFilters.updateFilters,
      filtersString = _useFilters.filtersString;

  var ongoingFetches = (0,useIsFetching/* useIsFetching */.y)({
    queryKey: ["recipes"]
  });
  var isQueryLoading = ongoingFetches > 0;

  var _useFeaturedRecipesQu = (0,queries/* useFeaturedRecipesQuery */.d_)({
    args: [{
      max: 3
    }]
  }),
      featuredRecipes = _useFeaturedRecipesQu.data;

  var _useRecipesGrid = RecipesGrid_useRecipesGrid({
    query: debouncedQuery,
    filters: filtersString
  }),
      flattenedPages = _useRecipesGrid.flattenedPages,
      isEmpty = _useRecipesGrid.isEmpty,
      nextPageTrigger = _useRecipesGrid.nextPageTrigger,
      hasNextPage = _useRecipesGrid.hasNextPage;

  var showFeaturedRecipes = debouncedQuery === "" && filtersString === "" && featuredRecipes;
  var showFooter = !hasNextPage;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: Recipes_copy.pageTitle,
      pageDescription: Recipes_copy.pageDescription,
      pageOG: (OgRecipes_default()),
      bodyBackground: theme.palette.neutrals.white[100],
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
        query: query,
        onQueryChange: setQuery,
        isQueryLoading: isQueryLoading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_Filters, {
          onFilterChange: updateFilters
        }), showFeaturedRecipes && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedRecipes_FeaturedRecipes, {
            recipes: featuredRecipes
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecipeDivider_RecipeDivider, {})]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecipesGrid_RecipesGrid, {
          recipes: flattenedPages,
          isEmpty: isEmpty,
          isLoading: isQueryLoading,
          title: getCardsSectionTitle(debouncedQuery, filtersString),
          nextPageTrigger: nextPageTrigger
        }), isEmpty && featuredRecipes && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecipeDivider_RecipeDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedRecipes_FeaturedRecipes, {
            recipes: featuredRecipes
          })]
        }), showFooter && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), showFooter && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var Recipes = (RecipesView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1o08ypk0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/api/algolia/client.ts
var client = __webpack_require__(2017);
// EXTERNAL MODULE: ../../libs/api/routes/recipes/contexts/algoliaClientContext.ts
var algoliaClientContext = __webpack_require__(57447);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/recipes/index.tsx







var RecipesPage = function RecipesPage() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  var algoliaClient = (0,react.useMemo)(function () {
    return (0,client/* createClient */.e)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(algoliaClientContext/* AlgoliaClientProvider */.vS, {
      value: algoliaClient,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Recipes, {})
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var recipes = (RecipesPage);

/***/ }),

/***/ 2017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ createClient; }
/* harmony export */ });
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61970);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);


var createClient = function createClient() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  return algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()((_process$env$NEXT_PUB = "16K0JFOELG") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "", (_process$env$NEXT_PUB2 = "d8d6f81bd62f98b1e42cce94c827afd2") !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};



/***/ }),

/***/ 57447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ei": function() { return /* binding */ useRecipesIndex; },
/* harmony export */   "vS": function() { return /* binding */ AlgoliaClientProvider; }
/* harmony export */ });
/* unused harmony exports AlgoliaClientContext, useAlgoliaClient, createRecipesIndex, useRecipesSearchIndex, createRecipesSearchIndex */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* provided dependency */ var process = __webpack_require__(34406);

var AlgoliaClientContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var AlgoliaClientProvider = AlgoliaClientContext.Provider;
var useAlgoliaClient = function useAlgoliaClient() {
  var AlgoliaClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AlgoliaClientContext);

  if (!AlgoliaClient) {
    throw new Error("Recipes index isn't available. Please set it via AlgoliaClientProvider component.");
  }

  return AlgoliaClient;
};
var useRecipesIndex = function useRecipesIndex() {
  var client = useAlgoliaClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createRecipesIndex(client);
  }, [client]);
};
var createRecipesIndex = function createRecipesIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = "Recipes") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};
var useRecipesSearchIndex = function useRecipesSearchIndex() {
  var client = useAlgoliaClient();
  return useMemo(function () {
    return createRecipesSearchIndex(client);
  }, [client]);
};
var createRecipesSearchIndex = function createRecipesSearchIndex(client) {
  var _process$env$NEXT_PUB2;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_RECIPES_SEARCH) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};

/***/ }),

/***/ 67723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d_": function() { return /* reexport */ useFeaturedRecipesQuery; },
  "s_": function() { return /* reexport */ useFiltersQuery; },
  "R0": function() { return /* reexport */ useRecipesQuery; },
  "id": function() { return /* reexport */ useSingleRecipeQuery; }
});

// UNUSED EXPORTS: createAllRecipesQuery, createFeaturedRecipesQuery, createFiltersQuery, createRecipesQuery, createSingleRecipeQuery, useAllRecipesQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/api/types/recipe.ts
var isTool = function isTool(value) {
  return ["name", "type"].every(function (key) {
    return key in value;
  });
};
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/recipes.ts






function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var fetchAllRecipes = function fetchAllRecipes(client, options) {
  return client.get("/content/entries/recipe", options).then(function (res) {
    var transformedResponse = res.map(function (recipe) {
      var _recipe$authors, _recipe$ogImage, _recipe$ogImage2, _recipe$requiredTools, _recipe$useCases;

      return _objectSpread(_objectSpread({}, recipe), {}, {
        authors: (_recipe$authors = recipe.authors) === null || _recipe$authors === void 0 ? void 0 : _recipe$authors.map(function (author) {
          var _author$fields$headsh, _author$fields$headsh2, _author$fields$compan, _author$fields$compan2;

          return _objectSpread(_objectSpread({}, author.fields), {}, {
            headshot: {
              title: author.fields.headshot.fields.title,
              src: author.fields.headshot.fields.file.url,
              width: (_author$fields$headsh = author.fields.headshot.fields.file.details.image) === null || _author$fields$headsh === void 0 ? void 0 : _author$fields$headsh.width,
              height: (_author$fields$headsh2 = author.fields.headshot.fields.file.details.image) === null || _author$fields$headsh2 === void 0 ? void 0 : _author$fields$headsh2.height
            },
            companyLogo: {
              title: (_author$fields$compan = author.fields.companyLogo) === null || _author$fields$compan === void 0 ? void 0 : _author$fields$compan.fields.title,
              src: (_author$fields$compan2 = author.fields.companyLogo) === null || _author$fields$compan2 === void 0 ? void 0 : _author$fields$compan2.fields.file.url
            }
          });
        }),
        ogImage: {
          src: (_recipe$ogImage = recipe.ogImage) === null || _recipe$ogImage === void 0 ? void 0 : _recipe$ogImage.fields.file.url,
          title: (_recipe$ogImage2 = recipe.ogImage) === null || _recipe$ogImage2 === void 0 ? void 0 : _recipe$ogImage2.fields.title
        },
        requiredTools: (_recipe$requiredTools = recipe.requiredTools) === null || _recipe$requiredTools === void 0 ? void 0 : _recipe$requiredTools.map(function (tool) {
          return tool.fields;
        }),
        useCases: (_recipe$useCases = recipe.useCases) === null || _recipe$useCases === void 0 ? void 0 : _recipe$useCases.map(function (useCase) {
          return useCase.fields;
        })
      });
    });
    return sortBy_default()(transformedResponse, function (item) {
      return item.title;
    });
  });
};
var fetchFeaturedRecipes = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var client, _ref$max, max, options, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, _ref$max = _ref.max, max = _ref$max === void 0 ? 3 : _ref$max, options = _ref.options;
            _context.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            data = _context.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeaturedRecipes(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchRecipe = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
    var client, options, slug, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context2.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            data = _context2.sent.find(function (item) {
              return item.slug === slug;
            });
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchRecipe(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var fetchFilters = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref5) {
    var client, filtersObjs, options, allRecipes, filters;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref5.client, filtersObjs = _ref5.filtersObjs, options = _ref5.options;
            _context3.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            allRecipes = _context3.sent;
            filters = filtersObjs.map(function (_ref7) {
              var id = _ref7.id,
                  displayName = _ref7.displayName,
                  searchableId = _ref7.searchableId;
              var options = allRecipes.reduce(function (acc, recipe) {
                if (recipe[id]) {
                  var value = recipe[id];
                  if (typeof value === "string") acc.push(value);else if (Array.isArray(value) && value.some(function (el) {
                    return typeof el === "object" && isTool(el);
                  })) value.map(function (el) {
                    return acc.push(el.name);
                  });else if (Array.isArray(value)) acc.push.apply(acc, (0,toConsumableArray/* default */.Z)(value));else {
                    throw new Error("Unexpected value type for filter ".concat(id));
                  }
                }

                return acc;
              }, []);
              return {
                id: id,
                searchableId: searchableId,
                displayName: displayName,
                options: sortBy_default()(Array.from(new Set(options)).map(function (option) {
                  return {
                    value: option,
                    text: option
                  };
                }), function (opt) {
                  return opt.value.toLowerCase();
                })
              };
            });
            return _context3.abrupt("return", filters);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchFilters(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/allRecipesQuery.ts



var createAllRecipesQuery = function createAllRecipesQuery(client) {
  return [["recipes", "allRecipesQuery"], function () {
    return fetchAllRecipes(client);
  }];
};
var useAllRecipesQuery = (0,createQueryHook/* default */.Z)(createAllRecipesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/featuredRecipesQuery.ts



var createFeaturedRecipesQuery = function createFeaturedRecipesQuery(client, _ref) {
  var max = _ref.max;
  return [["recipes", "featuredRecipesQuery", max], function (_ref2) {
    var signal = _ref2.signal;
    return fetchFeaturedRecipes({
      client: client,
      max: max,
      options: {
        signal: signal
      }
    });
  }];
};
var useFeaturedRecipesQuery = (0,createQueryHook/* default */.Z)(createFeaturedRecipesQuery, staticSiteBackend/* useStaticSiteBackend */.gR);
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/filtersQuery.ts



var defaultFilters = [{
  id: "roles",
  searchableId: "teams",
  displayName: "Teams"
}, {
  id: "experienceLevel",
  searchableId: "experienceLevel",
  displayName: "Experience Level"
}, {
  id: "industries",
  searchableId: "industries",
  displayName: "Industry"
}, {
  id: "requiredTools",
  searchableId: "requiredTools.name",
  displayName: "Tools"
}];
var createFiltersQuery = function createFiltersQuery(client) {
  var filtersObjs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFilters;
  return [["recipes", "filters"], function (_ref) {
    var signal = _ref.signal;
    return fetchFilters({
      client: client,
      filtersObjs: filtersObjs,
      options: {
        signal: signal
      }
    });
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
;// CONCATENATED MODULE: ../../libs/api/algolia/recipes.ts
/* provided dependency */ var process = __webpack_require__(34406);





function recipes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function recipes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? recipes_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : recipes_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var attributesToFetch = ["slug", "title", "description", "roles", "authors", "industries", "teams", "experienceLevel"];
var fetchRecipes = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var query, searchIndex, _ref$page, page, _ref$distinct, distinct, hitsPerPage, filters, cacheKey, enabled, algoliaCachedSearch;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, searchIndex = _ref.searchIndex, _ref$page = _ref.page, page = _ref$page === void 0 ? 0 : _ref$page, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, filters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return (0,fsCache/* createFsCacheProxy */.c)(["recipes-fetchRecipes"].concat((0,toConsumableArray/* default */.Z)(cacheKey ? cacheKey : [query, page !== null && page !== void 0 ? page : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, filters !== null && filters !== void 0 ? filters : null])), function () {
              return searchIndex.search.apply(searchIndex, arguments).then(function (res) {
                return recipes_objectSpread(recipes_objectSpread({}, res), {}, {
                  hits: res.hits.map(function (hit) {
                    var _hit$authors;

                    return recipes_objectSpread(recipes_objectSpread({}, hit), {}, {
                      authors: (_hit$authors = hit.authors) === null || _hit$authors === void 0 ? void 0 : _hit$authors.map(function (author) {
                        return recipes_objectSpread(recipes_objectSpread({}, author), {}, {
                          headshot: {
                            title: author.headshot.fields.title,
                            src: author.headshot.fields.file.url
                          }
                        });
                      })
                    });
                  })
                });
              });
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: page,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRecipes(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../libs/api/routes/recipes/contexts/algoliaClientContext.ts
var algoliaClientContext = __webpack_require__(57447);
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/recipesQuery.ts





var createRecipesQuery = function createRecipesQuery(searchIndex, _ref) {
  var query = _ref.query,
      hitsPerPage = _ref.hitsPerPage,
      filters = _ref.filters;
  return [["recipes", "recipesQuery", query, hitsPerPage, filters], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var pageParam;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              return _context.abrupt("return", fetchRecipes({
                searchIndex: searchIndex,
                page: pageParam,
                query: query,
                filters: filters,
                hitsPerPage: 6
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
var useRecipesQuery = (0,createInfinityQueryHook/* default */.Z)(createRecipesQuery, algoliaClientContext/* useRecipesIndex */.ei, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(_ref4) {
    var _ref4$page = _ref4.page,
        page = _ref4$page === void 0 ? 0 : _ref4$page;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(_ref5) {
    var _ref5$page = _ref5.page,
        page = _ref5$page === void 0 ? 0 : _ref5$page,
        nbPages = _ref5.nbPages;
    var nextPage = page + 1;

    if (nextPage >= nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/singleRecipeQuery.ts



var createSingleRecipeQuery = function createSingleRecipeQuery(client, slug) {
  return [["recipes/singleRecipeQuery", slug], function () {
    return fetchRecipe({
      client: client,
      slug: slug
    });
  }];
};
var useSingleRecipeQuery = (0,createQueryHook/* default */.Z)(createSingleRecipeQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/recipes/queries/index.ts






/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 16046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useIntersectionObserver_useIntersectionObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useEventCallback/index.ts
var useEventCallback = __webpack_require__(93026);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/useIntersectionObserver.ts



var isRef = function isRef(ref) {
  return typeof ref !== "string";
};

var validSelector = function validSelector(slug) {
  var selector = slug.trim();

  if (selector && selector.match(/^\d/)) {
    selector = selector.replace(/^[0-9]+/, "");
    selector = selector.startsWith("-") ? selector.replace("-", "") : selector;
  }

  return selector;
};
/**
 * A hook to observe elements in the viewport
 * @param refs - An array of refs or selectors
 * @param callback - The function to call when an element is intersecting
 * @param options - The options for the IntersectionObserver
 * @returns An object containing the update function to update the observed elements and the observer reference
 */


var useIntersectionObserver = function useIntersectionObserver(refs, callback, options) {
  var observerRef = (0,react.useRef)();
  var currentlyObserved = (0,react.useRef)(Array.from({
    length: refs.length
  }).fill(null));

  var _useState = (0,react.useState)(0),
      updateCount = _useState[0],
      setUpdateCount = _useState[1];

  var callbackHandle = (0,useEventCallback/* default */.Z)(callback, []);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(callbackHandle, options);
    observerRef.current = intersectionObserver;
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (element && currentlyObserved.current) {
        intersectionObserver.observe(element);
        currentlyObserved.current[index] = element;
      }
    });
    return function () {
      intersectionObserver.disconnect();
      currentlyObserved.current = null;
    };
  }, [updateCount, callbackHandle]);
  var update = (0,react.useCallback)(function () {
    return setUpdateCount(function (state) {
      return ++state;
    });
  }, []); // Update observed element
  // JSX is changing and observed element can be mounted and unmounted from jsx tree
  // This effect takes care of updating currently observed element to newest reference value

  (0,react.useEffect)(function () {
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (observerRef.current && currentlyObserved.current) {
        var areDifferent = currentlyObserved.current[index] !== element;

        if (currentlyObserved.current[index] && areDifferent && isRef(ref)) {
          var _observerRef$current;

          (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 ? void 0 : _observerRef$current.unobserve(currentlyObserved.current[index]);
          currentlyObserved.current[index] = null;
        }

        if (areDifferent && element && isRef(ref)) {
          var _observerRef$current2;

          (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 ? void 0 : _observerRef$current2.observe(element);
          currentlyObserved.current[index] = element;
        }
      }
    });
  });
  return {
    observerRef: observerRef,
    update: update
  };
};

/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = (useIntersectionObserver);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/index.ts


/***/ }),

/***/ 78299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useNextPageTrigger_useNextPageTrigger; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useIntersectionObserver/index.ts + 1 modules
var useIntersectionObserver = __webpack_require__(16046);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/useNextPageTrigger.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




/**
 * A hook that triggers the next page when the element is in view.
 * @param props.isLoading Whether the next page is loading.
 * @param props.onNextPage The function to call when the next page should be loaded.
 * @param props.loadMargin The margin to use when loading the next page.
 * @param props.totalDownloadedPages The total number of downloaded pages.
 * @param props.hasNextPage Whether there is a next page.
 * @param props.error The error that occurred while loading the next page.
 * @param props.NextPageTrigger The component to render as the next page trigger.
 * @returns The React component to render as the next page trigger.
 */

var useNextPageTrigger = function useNextPageTrigger(_ref) {
  var isLoading = _ref.isLoading,
      onNextPage = _ref.onNextPage,
      loadMargin = _ref.loadMargin,
      pageLength = _ref.totalDownloadedPages,
      hasNextPage = _ref.hasNextPage,
      error = _ref.error,
      _ref$NextPageTrigger = _ref.NextPageTrigger,
      NextPageTrigger = _ref$NextPageTrigger === void 0 ? DefaultNextPageTrigger : _ref$NextPageTrigger;
  var nextPageTriggerRef = (0,react.useRef)(null);
  var isInView = (0,react.useRef)(false);
  (0,useIntersectionObserver/* default */.Z)([nextPageTriggerRef], function (intersections) {
    var isInViewValue = intersections.some(function (i) {
      return i.isIntersecting;
    });
    isInView.current = isInViewValue;

    if (isLoading) {
      return;
    }

    if (isInViewValue && hasNextPage) {
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    }
  }, {
    rootMargin: loadMargin,
    threshold: [1]
  });
  (0,react.useEffect)(function () {
    if (!isLoading && isInView.current && hasNextPage) {
      // eslint-disable-next-line no-warning-comments
      // TODO: This `onNextPage()` call should be revisited since it is fetching pagination data twice
      // check out on /customers, /recipes, /catalog, /growth-masters/curriculum
      // Maybe we should remove this useEffect entirely and refactor this hook.
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoading, pageLength, hasNextPage]); // Split it to simplify typescript compilation

  var El = NextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(El, {
    ref: nextPageTriggerRef,
    error: error
  });
};

/* harmony default export */ var useNextPageTrigger_useNextPageTrigger = (useNextPageTrigger);

var DefaultNextPageTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11u9tnv0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/index.ts


/***/ }),

/***/ 67184:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes",
      function () {
        return __webpack_require__(76097);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _useTimeoutFn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45641);


function useDebounce(fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    var _a = (0,_useTimeoutFn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(reset, deps);
    return [isReady, cancel];
}


/***/ }),

/***/ 45641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeoutFn; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var callback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
    var isReady = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () { return ready.current; }, []);
    var set = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}


/***/ }),

/***/ 27305:
/***/ (function(module) {

module.exports = "/_next/static/images/OgRecipes-4dbc025ed73c6e52399c0da62a980448.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,8943,1970,6861,1382,4136,2073,8392,5735,2429,7303,948,8187,442,4881,9550,6818,2389,9774,2888,179], function() { return __webpack_exec__(67184); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);